module.exports = __webpack_public_path__ + "img/pie-chart-02.3aa840c1.svg";